<div class="close-button-container" (click)="dismiss()"><smart-icon name="f" ></smart-icon></div>
<swiper [pagination]="{clickable: true}" [initialSlide]="this.activeIndex" #gallerySlides [zoom]="true">
  <ng-template swiperSlide *ngFor="let image of this.images">
    <zoomable-image [image]="image" (zoomChanged)="this.isZooming($event)"></zoomable-image>
  </ng-template>
</swiper>


